module.exports = __webpack_public_path__ + "static/icnkr-ba11625caefa7b6393db7d7d779c6cfc.png";